import { call, all }             from 'redux-saga/effects';
import submit_approved_user_form from './submit_approved_user_form';

export default function* indexSaga(){
  yield all([
    call(submit_approved_user_form)
  ])
}